module.exports = __webpack_public_path__ + "img/maigret-tiene-miedo.f1f0ab07.jpg";